import { indexCategories } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            影片分类
          </h2>
          <p className="text-sm text-foreground-600">
            九大分类，快速找到你想看的类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-9 gap-3">
          {indexCategories.map((cat, i) => (
            <div
              key={i}
              className="flex flex-col items-center gap-2 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200/50 hover:bg-background-50 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-xs md:text-sm font-medium text-foreground-800 text-center whitespace-nowrap">
                {cat.name}
              </h3>
              <span className="text-[10px] md:text-xs text-foreground-500">
                {cat.count}部
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}